var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransactionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.14563 8.96228L12.4958 8.96228",
    stroke: "#585D66",
    strokeWidth: 1.51822
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.15768 11.9993L2.62732 8.96289L4.97694 8.96289",
    stroke: "#585D66",
    strokeWidth: 1.51822
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.71228 5.42126L1.61512 5.42126",
    stroke: "#585D66",
    strokeWidth: 1.51822
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.70011 2.38416L11.2305 5.42059L8.88085 5.42059",
    stroke: "#585D66",
    strokeWidth: 1.51822
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionIcon);
export default __webpack_public_path__ + "static/media/transaction-icon.78cf9358fb7177a90bc31a7b9a33326e.svg";
export { ForwardRef as ReactComponent };